import { Controller, useFormContext } from "react-hook-form";

import FormField, { FormFieldProps } from "ds/components/Form/Field";
import SpaceSelect from "components/SpaceSelect";
import { Space } from "types/generated";

import FormFieldSpaceTooltipInfo from "./TooltipInfo";

type FormFieldSpaceProps = Pick<
  FormFieldProps,
  | "tooltipAnalyticsPage"
  | "tooltipAnalyticsProps"
  | "tooltipAnalyticsTitle"
  | "noMargin"
  | "tooltipInfo"
> & {
  loading?: boolean;
  disabled?: boolean;
  label?: string;
  spaces?: Space[];
};

const FormFieldSpace = ({
  disabled,
  loading,
  tooltipInfo,
  label = "Space",
  spaces,
  ...rest
}: FormFieldSpaceProps) => {
  const { control } = useFormContext<{ space: string }>();

  return (
    <Controller
      name="space"
      control={control}
      rules={{ required: `${label} field is required.` }}
      render={({ field, fieldState }) => (
        <FormField
          {...rest}
          error={fieldState.error?.message}
          label={label}
          tooltipInfoVariant="modal"
          tooltipInfo={tooltipInfo || <FormFieldSpaceTooltipInfo />}
        >
          {({ ariaInputProps }) => (
            <SpaceSelect
              ref={field.ref}
              value={field.value}
              onChange={field.onChange}
              error={!!fieldState.error?.message}
              loading={loading}
              disabled={disabled}
              ariaProps={ariaInputProps}
              spaces={spaces}
            />
          )}
        </FormField>
      )}
    />
  );
};

export default FormFieldSpace;
